module.exports = __webpack_public_path__ + "fd1d01f84c35fdbdeaa644f48c410394.MP3";